import NGODashboardLayout from "layout/dashboardlayout/ngodashboardlayout.js";
import React, { useEffect } from "react";
import Details from "./Details";
import Table from "shared/Table";
import { TRANSACTIONTABLECOLUMN } from "utilities/data";
import { useDispatch, useSelector } from "react-redux";
import {
  getNgoTransactions,
  getNgoWalletAmount,
} from "appState/transaction/transactionSlice";

const NGOTransactionsLayout = () => {
  const { transactions } = useSelector((state) => state.transaction);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getNgoTransactions());
    dispatch(getNgoWalletAmount());
  }, [dispatch]);

  return (
    <NGODashboardLayout
      section="Transactions"
      infoText="Manage your transactions all in one place"
    >
      <div className="bg-white rounded-md p-6 max-[450px]:p-3">
        <Details />
        <Table
          columns={TRANSACTIONTABLECOLUMN}
          data={transactions}
          pagination
        />
      </div>
    </NGODashboardLayout>
  );
};

export default NGOTransactionsLayout;
